import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SELECTED_SAVED_SEARCH_URL_KEY } from '../../components/SavedSearchesDropdown/SavedSearchesDropdown.constants';

export default (): [string | null, (string) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();

  const selectedSearchId = useMemo(() => searchParams.get(SELECTED_SAVED_SEARCH_URL_KEY), [searchParams]);

  const setSelectedSavedSearch = useCallback(
    (id: string) => {
      searchParams.set(SELECTED_SAVED_SEARCH_URL_KEY, id);
      setSearchParams(searchParams);
    },
    [searchParams, setSearchParams]
  );

  return [selectedSearchId, setSelectedSavedSearch];
};
